// extracted by mini-css-extract-plugin
module.exports = {"gameCards":"_7e914ec","cardsContainer":"_05374db","buttonContainer":"_ea448a6"};